'use strict';

const {fillWithShapeOptions, noMoreThan} = require('../utils/misc');
const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');

module.exports = new DrawingElement('poly-with-colors', function () {

    const select = this.query('select');
    fillWithShapeOptions(select, 3, 20, 6);

    const ratioInput = this.query('.polygon-ratio');
    const label = this.query('label.ratio');

    const _updateDrawing = () => {
        const shape = new Shape(parseInt(select.value, 10), Point.origin(), 100);
        shape.scaleToFitWithin(this.width - this.pad * 2, this.width - this.pad * 2);
        shape.setAnchorPoint(new Point(this.pad, this.pad));

        let ratio = parseInt(ratioInput.value, 10) / 100;
        label.innerText = ratio.toFixed(2);
        shape.setFractalProportion(ratio);
        let subShapes = shape.getProportionalSubShapes();

        this.wipe();
        shape.draw(this.ctx);
        const iteration = 360 / subShapes.length;
        const percent = Math.round(150 / subShapes.length);
        subShapes.forEach((shape, i) => {
            shape.fill(this.ctx, `hsl(${Math.round(i * iteration)}, 100%, 50%, ${percent}%)`);
        });
        subShapes.forEach((shape) => {
            shape.draw(this.ctx);
        });
    };
    const updateDrawing = noMoreThan(_updateDrawing, 100);

    ratioInput.addEventListener('input', updateDrawing);
    select.addEventListener('change', updateDrawing);

    updateDrawing();
});


